import { ControllerStore } from '@ayocore/platform/client/controllers/ControllerStore';
import logger from '@ayocore/platform/common/helpers/logger';
import type { DealReportClient, DealStatusAmounts } from '../shared/reportTypes';

export interface UserDealsWidgetState {
  stats: DealStatusAmounts;
  loading: boolean;
  error: string | null;
}

/** Полный цикл загрузки одного экземпляра виджета личных сделок. */
export class UserDealsWidgetController extends ControllerStore<UserDealsWidgetState> {
  private loadVersion = 0;

  constructor(private readonly repository: Pick<DealReportClient, 'getWelcomeDealStats'>) {
    super({ stats: [], loading: true, error: null });
  }

  async load(): Promise<void> {
    const version = ++this.loadVersion;
    this.setState({ stats: [], loading: true, error: null });
    try {
      const stats = await this.repository.getWelcomeDealStats();
      if (version === this.loadVersion) {
        this.setState({ stats, loading: false, error: null });
      }
    } catch (error) {
      if (version !== this.loadVersion) return;
      logger.error('Failed to load user deal stats:', error);
      this.setState({
        stats: [],
        loading: false,
        error: 'Не удалось загрузить сделки. Попробуйте ещё раз.',
      });
    }
  }

  /** Не применять ответ после размонтирования или повторного запуска эффекта. */
  cancelLoad(): void {
    this.loadVersion += 1;
  }
}
